// extracted by mini-css-extract-plugin
export default {"container":"styles__container___fzPKY","wide":"styles__wide___d5NDz"};